import { useState } from 'react'
import { Flex } from '@radix-ui/themes'
import { redirect, useNavigate } from 'react-router'
import { createClient } from '@/api-client'
import { Me } from '@/api-client/Me'
import { Subscriptions } from '@/api-client/Subscriptions'
import { SubscriptionMypageLayout } from '~/components/subscription/mypage-layout'
import { PageHeading } from '~/components/subscription/page-heading'
import { FormLabel } from '~/components/subscription/form-label'
import { Button } from '~/components/subscription/button'
import { styles } from './styles.css'

export const loader = async () => {
  return await createClient(Me)
    .getMe()
    .then(() => redirect('/subscription/mypage'))
    .catch(() => {}) // アカウント情報が取れなかったらログイン画面を表示
}

export const SubscriptionLogin: React.FC = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    try {
      await createClient(Subscriptions).postSubscriptionsSessions({
        email,
        password,
        signup: '0',
      })

      navigate('/subscription/mypage')
    } catch {
      setMessage('メールアドレスまたはパスワードが違います。')
    }
  }

  return (
    <SubscriptionMypageLayout>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Flex direction="column" align="center" justify="start" gap="40px" width="100%">
          <Flex direction="column" align="center" gap="32px" width="100%">
            <PageHeading>ログイン</PageHeading>
            <Flex direction="column" align="start" gap="8px" width="100%">
              <Flex direction="column" align="start" gap="4px" width="100%">
                <FormLabel htmlFor="email">メールアドレス</FormLabel>
                <input type="email" id="email" required className={styles.input} value={email} onChange={(e) => setEmail(e.target.value)} />
              </Flex>
              <Flex direction="column" align="start" gap="4px" width="100%">
                <FormLabel htmlFor="password">パスワード</FormLabel>
                <input type="password" id="password" required className={styles.input} value={password} onChange={(e) => setPassword(e.target.value)} />
              </Flex>
            </Flex>

            <Flex direction="column" align="center" gap="16px" mt="24px" width="100%">
              {message && <p className={styles.error}>{message}</p>}
              <Button as="button" type="submit" fluid={true}>
                ログイン
              </Button>
              <a href="/password_reset/new" className={styles.resetLink}>パスワードを忘れた場合はこちら</a>
            </Flex>
          </Flex>
        </Flex>
      </form>
    </SubscriptionMypageLayout>
  )
}
